import createDao from '@esentai/core/ducks/dao';
import { path } from 'ramda';

import api from './api';

export default createDao('benefit-item', {
  api,
  getRoot: path(['benefitGiveOutPage', 'query']),
});
